export default {
  title: "Identifiers for Item",
  hint: "<b>Hint:</b> Press on an Identifier to select it. This enables disassociation.",
  identifier_all:
    'Here are all the <b class="text-info">Identifiers</b> presently associated with this ' +
    '<b class="text-info">Item</b>.',
  identifier_none:
    'There are currently no <b class="text-info">Identifiers</b> associated with this ' +
    '<b class="text-info">Item</b>.',
}
